import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class GdprAutoConsentHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public schedule(): Observable<{ uuid: string }> {
    return this.httpApi.post(`gdpr/auto_consent`);
  }

  public loadCandidateCount(): Observable<{ candidatesCount: number }> {
    return this.httpApi.get('gdpr/auto_consent/count');
  }
}
